import React from 'react';

export default React.createClass({

	render: function(){

        let styles = this.props.style;

		return (
			<div style={styles} className='lui-tab-template'>
				{this.props.children}
			</div>
		);
	},
});


/** WEBPACK FOOTER **
 ** ./src/components/tabs/TabTemplate.js
 **/